import { AUTH_TOKEN } from "constants/AuthConstant";

export const isAuth = (response) => {
  // Only treat as unauthenticated when we actually have a token.
  const token = localStorage.getItem(AUTH_TOKEN);

  if (response?.statusCode === 401 && token) {
    return false;
  }

  return true;
};
